"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Useless class, the input element is too powerful to be so simple, use any of the WCAG classes instead
 */
class Input {
    constructor() {
        this.element = document.createElement("input");
    }
    setType(type) {
        this.element.type = type;
    }
    setValue(value) {
        this.element.value = value;
    }
}
exports.default = Input;
//# sourceMappingURL=Input.js.map